import React from 'react';
import classNames from 'classnames';

import * as styles from './forecasting-navigation-tabs.scss';
import { FORECASTING_PAGES, placeholdersWidths, PREDICTIONS_SUB_PAGES_IDS } from './const';

interface Props {
  topOffset: number;
  handleTabClick: (route: string) => void;
}

export const OnboardingInvoicesNavigationTabs = ({ topOffset, handleTabClick }: Props) => {
  return (
    <div className={styles.container} style={{ top: topOffset }}>
      {FORECASTING_PAGES.map(page => {
        if (page.id === PREDICTIONS_SUB_PAGES_IDS.PREDICTIONS_INVOICES) {
          return (
            <div
              key={page.id}
              className={classNames(styles.tab, {
                [styles.activeTab]: true
              })}
              style={{ marginRight: 16 }}
              onClick={() => handleTabClick(page.route)}
            >
              {page.linkComponent}
            </div>
          );
        }

        return <div key={page.id} className={styles.placeholderTab} style={{ width: placeholdersWidths[page.id] }} />;
      })}
    </div>
  );
};
